import React from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";

const cardStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  background: "white",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  borderRadius: "20px",
  padding: "20px",
  width: "100%",
};

const titleStyle = {
  fontSize: "18px",
  fontWeight: "bold",
  color: "#333",
  marginBottom: "15px",
};

const chartContainerStyle = {
  flex: 1,
  height: "240px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const legendContainerStyle = {
  flex: 1,
  paddingLeft: "20px",
};

const legendItemStyle = {
  display: "flex",
  alignItems: "center",
  marginBottom: "10px",
};

const legendColorBoxStyle = (color) => ({
  width: "20px",
  height: "20px",
  borderRadius: "4px",
  backgroundColor: color,
  marginRight: "10px",
});

const DashBoardCandidateChart = ({ dashboardData }) => {
  const dashboardChartData = dashboardData?.statusCounts || [];

  // Get counts from the specific status
  const shortlisted =
    dashboardChartData.find((item) => item.status === "shortlisted")?.count ||
    0;
  const interviewed =
    dashboardChartData.find((item) => item.status === "interviewed")?.count ||
    0;
  const onboarded =
    dashboardChartData.find((item) => item.status === "onboarded")?.count || 0;

  const data = [
    {
      value: dashboardData?.summaryStats?.totalEnteredByHr,
      name: "Total candidates",
      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: "rgba(28, 28, 28, 0.6)" },
        { offset: 1, color: "rgba(166, 166, 166, 0.8)" },
      ]),
    },
    {
      value: shortlisted,
      name: "Shortlisted  candidates",
      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: "#C7BDFF" },
        { offset: 1, color: "#5641C7" },
      ]),
    },
    {
      value: interviewed,
      name: "Interviewed  candidates",
      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: "#008CFF" },
        { offset: 1, color: "#B9E0FF" },
      ]),
    },
    {
      value: onboarded,
      name: "Onboarded  candidates",
      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: "#6678FF" },
        { offset: 1, color: "#061169" },
      ]),
    },
  ];

  const option = {
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c}", // Shows name and value
    },
    series: [
      {
        type: "pie",
        radius: ["50%", "85%"], // Increased width of the pie chart
        startAngle: -90,
        label: { show: false },
        data: data.map((item) => ({
          value: item.value,
          name: item.name,
          itemStyle: {
            color: item.color,
            borderWidth: 2,
            borderColor: "#FFFFFF",
            borderRadius: 10,
          },
        })),
      },
    ],
  };

  return (
    <div>
      <div style={cardStyle}>
        <div>
          <h2 style={titleStyle}>Candidate Status</h2>
          <div style={chartContainerStyle}>
            <ReactECharts
              style={{ height: "220px", width: "220px" }}
              option={option}
            />
          </div>
        </div>
        <div style={legendContainerStyle}>
          {data.map((item, index) => (
            <div key={index} style={legendItemStyle}>
              <div
                style={legendColorBoxStyle(
                  item.color.colorStops
                    ? item.color.colorStops[0].color
                    : "#000"
                )}
              ></div>
              <div style={{ fontSize: "14px", fontWeight: "bold" }}>
                {item.name}: {item.value}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashBoardCandidateChart;
